import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { replaceQuotationMarksWithGuillemets } from "../../../util/format/guillemets";
import format from "date-fns/format/index";
import de from "date-fns/locale/de";
var ContentRelatedArticles = function ContentRelatedArticles(props) {
    var articles = props.articles;
    return /*#__PURE__*/ React.createElement("div", {
        className: "border-t border-b border-gray-600 border-solid bg-makroOrangeLight p-2 pt-0 my-6",
        key: props.index
    }, articles.map(function (_ref, index) {
        var date = _ref.publishDate, title = _ref.title, image = _ref.image, authors = _ref.authors, id = _ref.id, slug = _ref.slug;
        return /*#__PURE__*/ React.createElement(Link, {
            to: "/" + slug + "/",
            className: "flex flex-wrap mt-2",
            key: id
        }, image && /*#__PURE__*/ React.createElement("div", {
            className: "hidden sm:contents w-32"
        }, /*#__PURE__*/ React.createElement(Img, {
            fixed: image.fixed,
            className: "shadow-lg mr-2"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "flex-1"
        }, index == 0 && /*#__PURE__*/ React.createElement("p", {
            className: "content-text font-bold text-makroOrange mb-1"
        }, "Lesen Sie auch:"), /*#__PURE__*/ React.createElement("p", {
            className: "content-text font-bold h0",
            style: {
                color: "#323232"
            }
        }, replaceQuotationMarksWithGuillemets(title)), /*#__PURE__*/ React.createElement("p", null, authors === null || authors === void 0 ? void 0 : authors.map(function (a) {
            return a.name ? a.name : (a.firstname || "") + " " + (a.lastname || "");
        }).join(", "), " ", "| ", format(new Date(date), "dd. MMMM yyyy", {
            locale: de
        }))));
    }));
};
export default ContentRelatedArticles;
